<template>
  <tr class="reports-table-virtual-row skip-hover">
    <td
      colspan="100%"
      class="reports-table-virtual-td p-0"
      :class="[
        { 'skip-hover': skipTableHover || rows.length > 1 },
        { 'without-corner-padding': mainColumnWithoutCornerPadding }
      ]"
    >
      <VirtualList
        page-mode
        :data-key="dataKey"
        :data-component="rowComponent"
        :data-sources="rows"
        :extra-props="rowExtraProps"
        :keeps="realItemsCount"
        :estimate-size="estimatedItemSize"
        :item-class="itemClasses"
        :class="listClass"
      />
    </td>
  </tr>
</template>

<script>
import { markRaw } from 'vue';
import VirtualList from 'vue3-virtual-scroll-list';
import { mapGetters } from "vuex";
import ReportVirtualTableRow from '~/components/reports/ReportVirtualTableRow.vue';

export default {
  name: 'ReportVirtualTableBody',
  components: {
    VirtualList,
  },
  props: {
    dataKey: {
      type: String,
      default: 'uuid',
    },
    rows: {
      type: Array,
      required: true,
    },
    realItemsCount: {
      type: Number,
      default: 30,
    },
    itemSize: {
      type: Number,
      default: 0,
      required: false,
    },
    itemClass: {
      type: String,
      default: '',
    },
    virtualListClass: {
      type: String,
      default: '',
    },
    virtualTableClass: {
      type: String,
      default: '',
    },
    nested: {
      type: Boolean,
      default: false,
    },
    skipTableHover: {
      type: Boolean,
      default: false,
    },
    mainColumnWithoutCornerPadding: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['virtualTableItemSize']),
    listClass() {
      const defaultClass = 'report-table-virtual-list';

      return [defaultClass, this.virtualListClass].filter((c) => !!c);
    },
    tableClasses() {
      const defaultClasses = 'table table-hover reports-table virtual-reports-table';

      return [
        defaultClasses,
        this.virtualTableClass,
        this.nested && 'table-nested',
        this.nested && 'bg-transparent',
      ].filter((c) => !!c);
    },
    itemClasses() {
      return `${this.itemClass} grouping`;
    },
    estimatedItemSize() {
      return this.itemSize || this.$store?.getters?.virtualTableItemSize || 0;
    },
    rowComponent() {
      return markRaw(ReportVirtualTableRow);
    },
    rowExtraProps() {
      return {
        tableClasses: this.tableClasses,
        rowSlot: this.$slots.default,
      };
    },
  }
};
</script>
